import { Section, Cards } from "./Features.styled";
import FeatureCard from "./FeatureCard";
import { features } from "../../data/FeaturesData";
import styled from "styled-components";

const H2 = styled.h2`
  margin-bottom: 16px;
  color: #0f172a;
  font-weight: 700;
  font-size: 2rem;
`;

const Features = () => {
  return (
    <Section id="features">
      <H2>Features</H2>
      <Cards>
        {features?.map((object, idx) => (
          <FeatureCard key={object.key} feature={object} idx={idx} />
        ))}
      </Cards>
    </Section>
  );
};

export default Features;
